import type { PeriodI } from "@lxc/app-device-common";
import type { Dayjs } from "dayjs";
import dayjs from "dayjs";
import LocalizedFormat from "dayjs/plugin/localizedFormat";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(LocalizedFormat);

export function getDateInTheFutureInMonth(
  numbersOfMonth: number,
  formatted = false,
) {
  const date = dayjs().add(numbersOfMonth, "month").utc();
  return formatted ? date.format("YYYY-MM-DDTHH:mm:ss[Z]") : date.format();
}

export function getDateToLocaleString(dateUtc: string): string {
  return dayjs(dateUtc).format("L LT");
}

export function getDateToLocalizedFormat(date: string): string {
  return dayjs(date).format("L");
}

export function formatIsoDate(
  isoDate: string | number | Date | Dayjs | null | undefined,
  format: string,
): string {
  return dayjs(isoDate).format(format);
}

export function formatIsoDateToUtc(
  isoDate: string | number | Date | Dayjs | null | undefined,
  format = "YYYY-MM-DDTHH:mm:ss[Z]",
): string {
  return dayjs(isoDate).utc().format(format);
}

export function timeLimitInMonthOrDays(
  endDate?: string,
  days?: boolean,
): number {
  const today = dayjs();
  return days
    ? dayjs(endDate).diff(today, "days")
    : dayjs(endDate).diff(today, "month", true);
}

/**
 * Return a period from the start of the start date to the end of the end date
 * If the start date is not provided, use today instead
 * If the end date is not provided, use today instead
 * @param startDate Date, optional
 * @param endDate Date, optional
 * @returns PeriodI
 */
export function getPeriod(
  startDate?: Date | null,
  endDate?: Date | null,
): PeriodI {
  // set default today if not provided
  startDate = startDate || new Date();
  endDate = endDate || new Date();

  // start of the start date => midnight
  startDate.setHours(0, 0, 0, 0);

  // end of the end date => midnight of the next day less 1 millisecond
  // this avoid to manage saving daylight manually
  endDate.setHours(0, 0, 0, 0);
  endDate.setDate(endDate.getDate() + 1);
  endDate.setMilliseconds(endDate.getMilliseconds() - 1);

  return {
    startDate,
    endDate,
  };
}

export function getDateYearMonthDayInDateFormat(
  dateYYYYMMDD: string,
  dateFormat: string,
) {
  const day = dayjs(dateYYYYMMDD, "YYYYMMDD");

  if (day.isValid()) {
    return dayjs(dateYYYYMMDD, "YYYYMMDD").format(dateFormat);
  } else {
    return dateYYYYMMDD;
  }
}

export function addMinutesToDate(date: Date, minutes: number): string {
  date.setMinutes(date.getMinutes() + minutes).toString();
  return getDateToLocaleString(date.toString());
}
